module.exports = __webpack_public_path__ + "static/media/collingwood-logo.c420f79e.svg";